// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xeRd","left":"styles_left__3pVeh"};